import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class SeoManagementService {
private readonly rootURL:string =environment.baseUrl;
  constructor(private http:HttpClient) { }
  manageSEOMater(seo: any): Observable<any> {
    return this.http.post<any>(this.rootURL + '/Common/ManageSEOMaster', seo);
  }
  getSEODetails(type:string,slug:string): Observable<any> {
    return this.http.get<any>(this.rootURL + '/Common/GetSEODetailByTypeAndSlug',{params:{type,slug}});
  }
}
